export interface ProductCategory {
    ClientKey?: string;
    Id: string;
    ProductCategoryName: string; 
    CustomFields?: { [key: string]: any };
}

